var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCloseDefault = function SvgCloseDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.466 12.013l6.23-6.23a1.035 1.035 0 10-1.466-1.466L12 10.547l-6.23-6.23a1.036 1.036 0 10-1.466 1.466l6.23 6.23-6.23 6.23A1.035 1.035 0 105.77 19.71L12 13.48l6.23 6.23a1.034 1.034 0 001.466 0 1.035 1.035 0 000-1.466l-6.23-6.23z",
    fill: "#9CA6AD"
  })));
};

export default SvgCloseDefault;